import React from 'react'

import ControlledModal from '../../../components/modals/ControlledModal'
import EditPlaceForm from './EditPlaceForm'
import ModalHeader from './ModalHeader'
import PlaceLoader from './_load/PlaceLoader'

const EditPlaceModal = props => {
  return (
    <ControlledModal width="42rem" disableClickOutside {...props}>
      <ModalHeader />
      <PlaceLoader>
        <EditPlaceForm />
      </PlaceLoader>
    </ControlledModal>
  )
}

export default EditPlaceModal
